module.exports = __webpack_public_path__ + "static/media/federato.61233822.png";